import { DatePipe } from "@angular/common";
import { Pipe, PipeTransform } from "@angular/core";
import { KeycloakHelperService } from "@core/services";
import { CountryCodeEnum } from "@shared/enums";

/**
 * date: It will display the year, month and day.
 *
 * dateWithHourMinutes: It will show the year, month and day.
 *  It will also show hours and minutes.
 */
type formatTypes = "date" | "dateWithHourMinutes";

const formatsBRA: Record<formatTypes, string> = {
  date: "dd/MM/yyyy",
  dateWithHourMinutes: "dd/MM/yyyy HH:mm"
};

const formatsUSA: Record<formatTypes, string> = {
  date: "MM/dd/yyyy",
  dateWithHourMinutes: "MM/dd/yyyy HH:mm"
};

const formatsARG: Record<formatTypes, string> = {
  date: "dd/MM/yyyy",
  dateWithHourMinutes: "dd/MM/yyyy HH:mm"
};

const formatNL: Record<formatTypes, string> = {
  date: "dd/MM/yyyy",
  dateWithHourMinutes: "dd/MM/yyyy HH:mm"
};

@Pipe({
    name: "countryDate",
    standalone: false
})
export class CountryDatePipe implements PipeTransform {
  constructor(private keycloakHelperService: KeycloakHelperService) {}

  private getFormat(formatType: formatTypes): string {
    switch (this.keycloakHelperService.getUserCountryCode()) {
      case CountryCodeEnum.BRAZIL:
        return formatsBRA[formatType];
      case CountryCodeEnum.ARGENTINA:
        return formatsARG[formatType];
      case CountryCodeEnum.UNITED_STATES:
        return formatsUSA[formatType];
      case CountryCodeEnum.NEDERLANDS:
        return formatNL[formatType];
      default:
        return formatsBRA[formatType];
    }
  }

  transform(value: string, formatType: formatTypes = "date"): string {
    if (!value || typeof value !== "string") return value;

    return new DatePipe("en-US").transform(value, this.getFormat(formatType));
  }
}
